export default __webpack_public_path__ + "img/6a55964742fdf07f6471496085db08b4.svg";